module.exports = __webpack_public_path__ + "media/images/flags/16/Nigeria-882cc790d9230b2c16709a47f0c78e68.png";